/**
 * SVG linear gradient used for `fill: url(#id)` via `--ai-icon-gradient`.
 * Endpoints match `--color-gradient-ai-dark` (see `src/index.css`).
 */
export const AI_BUTTON_ICON_LINEAR_GRADIENT_STOPS = [
  { offset: '0%', stopColor: 'var(--color-ai-primary)' },
  { offset: '100%', stopColor: 'var(--color-ai-gradient-icon-stop-end)' },
]

/** Shared layout for `<linearGradient>` (horizontal left → right) */
export const AI_BUTTON_ICON_LINEAR_GRADIENT_LAYOUT = {
  gradientUnits: 'objectBoundingBox',
  x1: '0%',
  x2: '100%',
  y1: '0%',
  y2: '0%',
}

/** `useId` prefix for debugging — keep unique per variant */
export const AIButtonIconGradientIdPrefix = {
  ContainedGrey: 'ai-button-contained-grey',
  ContainedLight: 'ai-button-contained-light',
  Icon: 'ai-button-icon',
  IconFlat: 'ai-button-icon-flat',
  IconGrey: 'ai-button-icon-grey',
  Outlined: 'ai-button-outlined',
  Text: 'ai-button-text',
  TextGrey: 'ai-button-text-grey',
}

export const AIButtonIconGradientSvgPlacement = {
  /** Zero-size, absolutely positioned next to the button (contained / outlined) */
  Embedded: 'embedded',
  /** Off-screen defs (text / icon-only — defs must survive loading branch) */
  Offscreen: 'offscreen',
}
